import { useQuery } from "@apollo/client/react";
import { GET_TIPO_MODULOS } from '../../../data/graphQL/queries/Contratos/DatosPrincipales/getTipoModulos';

export function useTipoModuloEnum() {
  const { data, loading, error } = useQuery(GET_TIPO_MODULOS);

  if (loading || error || !data) return { tipoModuloEnum: null, loading, error };

  const tipoModuloEnum = Object.freeze(
    data.allTipoModulo.reduce((acc, { abreviacion, idTipoModulo }) => {
      acc[abreviacion] = idTipoModulo;
      return acc;
    }, {})
  );

  const tipoModuloConIndicacion = Object.freeze(
    data.allTipoModulo.reduce((acc, { abreviacion, idTipoModulo, llevaIndicacion }) => {
      if (llevaIndicacion) {
        acc[abreviacion] = idTipoModulo;
      }
      return acc;
    }, {})
  );

  return { tipoModuloEnum, tipoModuloConIndicacion, loading, error };
}